import React from 'react';
import { makeStyles } from '@mui/styles';
import {
  Button,
  Grid,
  Menu,
  MenuItem,
  ListItemIcon,
  useMediaQuery,
  Typography,
  useTheme,
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import PrintIcon from '@mui/icons-material/Print';
import FilterListIcon from '@mui/icons-material/FilterList';
import ControlPointIcon from '@mui/icons-material/ControlPoint';
import FiltersPopup from '../../../../components/FiltersPopup';
import SaveFilterPopup from '../../../../components/SaveFilterPopup';

const useStyles = makeStyles(theme => ({
  button: {
    margin: theme.spacing(1),
    fontSize: 12,
    padding: '6px 16px',
  },
  '@global': {
    '.MuiListItemText-primary': {
      fontSize: '1rem',
      color: 'black',
    },
  },
}));

export default function ButtonPanel({ filters }) {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [anchorFilter, setAnchorFilter] = React.useState(null);
  const [anchorSaveFilter, setAnchorSaveFilter] = React.useState(null);

  const theme = useTheme();
  const lowerRes = useMediaQuery(theme.breakpoints.down('lg'));

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setAnchorFilter(null);
    setAnchorSaveFilter(null);
  };

  const handlePrint = () => {
    window.print();
    handleClose();
  };

  const handleDisplayFilters = event => {
    setAnchorFilter(event.currentTarget);
  };

  const handleDisplaySaveFilters = event => {
    setAnchorSaveFilter(event.currentTarget);
  };

  return (
    <>
      {lowerRes && (
        <Grid container direction="row" justify="flex-end" alignItems="center">
          <Grid item>
            <Button
              aria-controls="simple-menu"
              aria-haspopup="true"
              onClick={handleClick}
            >
              <MoreVertIcon />
            </Button>
            <Menu
              id="simple-menu"
              anchorEl={anchorEl}
              keepMounted
              open={Boolean(anchorEl)}
              onClose={handleClose}
            >
              <MenuItem onClick={handlePrint}>
                <ListItemIcon>
                  <PrintIcon />
                </ListItemIcon>
                <Typography variant="subtitle2" gutterBottom>
                  Print
                </Typography>
              </MenuItem>
              <MenuItem onClick={handleDisplayFilters}>
                <ListItemIcon>
                  <FilterListIcon />
                </ListItemIcon>
                <Typography variant="subtitle2" gutterBottom>
                  Display Filters
                </Typography>
              </MenuItem>
              <MenuItem onClick={handleDisplaySaveFilters}>
                <ListItemIcon>
                  <ControlPointIcon />
                </ListItemIcon>
                <Typography variant="subtitle2" gutterBottom>
                  Save New Filter Set
                </Typography>
              </MenuItem>
            </Menu>
          </Grid>
        </Grid>
      )}
      {!lowerRes && (
        <Grid container direction="row" justify="flex-end" alignItems="center">
          <Grid item>
            <Button
              variant="contained"
              color="inherit"
              size="small"
              className={classes.button}
              startIcon={<PrintIcon />}
              onClick={handlePrint}
            >
              Print
            </Button>
            <Button
              onClick={handleDisplayFilters}
              variant="contained"
              color="inherit"
              size="small"
              className={classes.button}
              startIcon={<FilterListIcon />}
            >
              Display Filters
            </Button>
            <Button
              onClick={handleDisplaySaveFilters}
              variant="contained"
              color="inherit"
              size="small"
              className={classes.button}
              startIcon={<ControlPointIcon />}
            >
              Save New Filter Set
            </Button>
          </Grid>
        </Grid>
      )}
      <FiltersPopup
        open={Boolean(anchorFilter)}
        anchorEl={anchorFilter}
        onClose={handleClose}
        filters={filters}
      />
      <SaveFilterPopup
        open={Boolean(anchorSaveFilter)}
        anchorEl={anchorSaveFilter}
        onClose={handleClose}
      />
    </>
  );
}
